var render = function render(){var _vm=this,_c=_vm._self._c;return _c('portal',{attrs:{"to":"confirm-modal"}},[(_vm.visible)?_c('local-notification-prompt',{key:_vm.promptKey,attrs:{"force-show":_vm.forceShow,"start-awaiting":_vm.startAwaiting,"unsupported":_vm.unsupported,"force-ios":_vm.forceIOS},on:{"close":_vm.onClose}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }